import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    currentPair: JSON.parse(localStorage.getItem('currentPair')) || 'BTCUSDT',
    pairType: JSON.parse(localStorage.getItem('pairType')) || 'crypto',
}

export const tradingSlice = createSlice({
    name: 'currentPair',
    initialState,
    reducers: {
        setcurrentPair: (state, action) => {
            state.currentPair = action.payload;  
            localStorage.setItem('currentPair', JSON.stringify(state.currentPair));
        } 
        ,
        setPairType: (state, action) => {
            state.pairType = action.payload;  
            localStorage.setItem('pairType', JSON.stringify(state.pairType));
        }       
    }
})

export const {setcurrentPair, setPairType} = tradingSlice.actions;
export default tradingSlice.reducer;